import { render, staticRenderFns } from "./cargarCompras.vue?vue&type=template&id=7de87ccb&"
import script from "./cargarCompras.vue?vue&type=script&lang=js&"
export * from "./cargarCompras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports